module.exports = __webpack_public_path__ + "static/media/Devi.cfd73de5.png";